import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  button: (props) => ({
    /* eslint-disable-next-line max-len */
    backgroundColor: (props.fill ? (props.invert ? theme.colors[props._color].lowestOpacity : theme.colors[props._color].normal) : 'transparent'),
    // eslint-disable-next-line max-len
    color: (props.invert || !props.fill ? theme.colors[props._color].normal : theme.colors[props._color].text),
    border: (props.outline ? `solid ${[1, 1, 1, 1.5, 1.5][['xs', 'sm', 'md', 'lg', 'xl'].indexOf(props._size)]}px ${theme.colors[props._color].normal}` : 'none'),
    borderRadius: (props.fab ? '100px' : `${theme.sizes.radius}px`),
    padding: (props.fab ? '0' : `0 ${theme.sizes.base}px`),
    '&:not([disabled]):focus, &:not([disabled]):hover': {
      backgroundColor: (
        props.fill ? (props.invert ? theme.colors[props._color].lowOpacity : theme.colors[props._color].hover) : 'rgba(0, 0, 0, 0.05)'
      ),
    },
    '&:not([disabled]):active': {
      backgroundColor: (
        props.fill ? (props.invert ? theme.colors[props._color].highOpacity : theme.colors[props._color].active) : 'rgba(0, 0, 0, 0.1)'
      ),
    },
    '&.loading': {
      color: 'transparent',
      minWidth: 60,
    },
  }),
  loading: () => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  }),
}));

export default useStyle;
